export default {
  notification: {
    success: {
      reply: 'Tweet respondido com sucesso!',
      remove: 'Página removida com sucesso!',
    },
    error: {
      reply: 'Erro ao responder ao tweet!',
      remove: 'Erro ao remover a página!',
    },
  },
  label: {
    pageSession: 'Selecione a página para responder:',
    pageLabel: 'Páginas',
    suggestionSession: 'Gere sugestões de resposta via chatGPT:',
    replySession: 'Edite a sugestão selecionada ou escreva uma resposta:',
    replyLabel: 'Responder @{username}',
    rules: {
      minChar: 'Necessário mínimo de {minChar} caracteres',
      maxChar: 'Permitido o máximo de {maxChar} caracteres',
    },
    button: {
      generateSuggestions: 'Gerar Sugestões',
      reply: 'Responder',
      remove: 'Remover',
    },
    status: {
      withoutData: 'Nenhuma publicação encontrada',
      errorData: 'Erro ao realizar a sua solicitação.',
    },
    closeLabel: 'Fechar',
  },
  faq: {
    question: 'Porque posso responder diretamente pelo componente apenas publicações do Twitter (X)?',
    response: 'Devido à limitações das APIs das outras redes sociais, não é permitido a criação de comentários em publicações de mar aberto, essa funcionalidade está disponível apenas para a rede social X (Twitter).',
  },
};
